import { TabletMockup } from "./TabletMockup";
import { useLanguage } from "../i18n/LanguageContext";
import { TitleLines } from "../i18n/text";

export function BenefitsSection() {
    const { t } = useLanguage();

    return (
        <section className="section benefitsSection" id="restaurants">
            <div className="sectionText">
                <p className="eyebrow">{t.benefits.eyebrow}</p>

                <h2>
                    <TitleLines lines={t.benefits.titleLines} />
                </h2>

                <p className="lead">{t.benefits.lead}</p>

                <div className="benefitGrid">
                    {t.benefits.items.map((item) => (
                        <article className="benefitCard" key={item.title}>
                            <span className="benefitIcon">{item.icon}</span>

                            <div>
                                <h3>{item.title}</h3>
                                <p>{item.text}</p>
                            </div>
                        </article>
                    ))}
                </div>
            </div>

            <div className="flowVisual" id="how">
                <div className="hoverHint">{t.benefits.hoverHint}</div>

                <div className="interactiveTabletWrap">
                    <TabletMockup variant="list" />
                </div>

                <div className="orderFlow">
                    <article className="flowCard dishFlowCard">
                        <img
                            className="flowDishImage"
                            src="/pictures/images/steak.png"
                            alt={t.benefits.steakAlt}
                        />

                        <h3>{t.benefits.steakName}</h3>
                        <p>{t.benefits.steakPicked}</p>
                        <strong>{t.benefits.steakPrice}</strong>

                        <button type="button" aria-label={t.benefits.addAria}>
                            +
                        </button>
                    </article>

                    <article className="flowCard">
                        <small>{t.benefits.yourOrder}</small>
                        <h3>{t.benefits.steakName}</h3>
                        <p>{t.benefits.steakOrderCount}</p>
                        <strong>{t.benefits.steakPrice}</strong>

                        <button className="smallGoldButton" type="button">
                            {t.benefits.placeOrder}
                        </button>
                    </article>

                    <article className="flowCard successCard">
                        <span>✓</span>
                        <h3>{t.benefits.paymentSuccess}</h3>
                        <p>{t.benefits.paymentThanks}</p>
                    </article>
                </div>

                <div className="flowNote">
                    {t.benefits.flowNoteBefore}{" "}
                    <b>{t.benefits.flowNoteSteps}</b>
                </div>
            </div>
        </section>
    );
}
